module.exports = __webpack_public_path__ + "static/media/listCases.792e9505.svg";